import sappayLogo from "../../assets/images/sappay-logo.svg";

function Layout({
  children,
  secondHalf = {
    img: {
      src: null,
      alt: null
    },
    content: null
  }
}) {
  return (
    <>
      <header className="header">
        <div className="main-container">
          <img className="brand" src={sappayLogo} alt="sappay logo" srcSet="" />
        </div>
      </header>
      <div className="layout main-container">
        <div className="half first">
          <div>{children}</div>
        </div>
        <div className="half second">
          {secondHalf.img && (
            <img src={secondHalf.img.src} alt={secondHalf.img.alt} srcSet="" />
          )}
          {secondHalf.content && (
            <div className="content">{secondHalf.content}</div>
          )}
          <p className="reserved">
            All right reserved SAPPAY © {new Date().getFullYear()}{" "}
          </p>
        </div>
      </div>
    </>
  );
}

export default Layout;
